import { UsersDto } from "users-experience-client";

export class UserContextHolder {

    private static user: UsersDto;

    private static listeners: Array<(user: UsersDto) => void> = [];

    public static init(user: UsersDto) {
        UserContextHolder.user = user;
        UserContextHolder.notifyListeners();
    }

    public static addListener(listener: (user: UsersDto) => void) {
        UserContextHolder.listeners.push(listener);
        if (UserContextHolder.user) {
            listener(UserContextHolder.user);
        }
    }

    private static notifyListeners() {
        UserContextHolder.listeners.forEach(listener => listener(UserContextHolder.getUser()!));
    }

    public static removeListener(listener: (user: UsersDto) => void) {
        const index = UserContextHolder.listeners.indexOf(listener);
        if (index > -1) {
            UserContextHolder.listeners.splice(index, 1);
        }
    }

    public static getUser(): UsersDto | undefined {
        return UserContextHolder.user;
    }
}